import React, { useEffect } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { IWorkProfile } from '../../types/global/helper';
import { DropdownSelect } from '../DropdownSelect/DropdownSelect';
import CustomButton from '../Button/CustomButton';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface ProfileSelectorProps {
    profiles?: IWorkProfile[];
    onProfileSelect: (profile: IWorkProfile) => void;
    onEditClick?: (profile: IWorkProfile) => void;
    external?: boolean;
    isEditMode?: boolean;
    onSaveClick?: () => void;
    onCancelClick?: () => void;
    sx?: SxProps<Theme>;
    mainSx?: SxProps<Theme>;
}

const WorkProfileSelector: React.FC<ProfileSelectorProps> = ({
    profiles,
    onProfileSelect,
    onEditClick,
    external,
    onSaveClick,
    onCancelClick,
    isEditMode,
    sx,
    mainSx,
}) => {
    const { themeStyle } = useThemeContext();

    const [selectedProfile, setSelectedProfile] = React.useState<IWorkProfile | undefined>();

    const handleChange = (index: number) => {
        const selectedProfile = profiles && profiles[index] && profiles[index];
        if (selectedProfile) {
            setSelectedProfile(selectedProfile);
            onProfileSelect(selectedProfile);
        }
    };

    useEffect(() => {
        if (profiles) {
            setSelectedProfile(profiles[0]);
            onProfileSelect(profiles[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box display="flex" alignItems="center" gap={1} justifyContent={'flex-end'} p={2} sx={mainSx}>
            {!external && (
                <CustomButton
                    label={isEditMode ? 'Cancel' : 'Edit'}
                    onClick={() =>
                        isEditMode && onCancelClick
                            ? onCancelClick()
                            : selectedProfile && onEditClick && onEditClick(selectedProfile)
                    }
                    sx={{
                        width: '200px',
                        borderRadius: '2px',
                        height: '60px',
                        '&:hover': {
                            WebkitTextFillColor: theme[themeStyle].primary_orange,
                        },
                    }}
                    customStyle={{
                        borderRadius: '8px',
                        height: '50px',
                    }}
                />
            )}

            {profiles && (
                <DropdownSelect
                    data={[
                        'Choose a profile',
                        ...profiles.map(p => {
                            return p.profile_type;
                        }),
                    ]}
                    label={''}
                    sx={{
                        width: {
                            xs: '100%',
                            sm: '200px',
                        },
                        ...sx,
                    }}
                    onOptionSelected={(_, index) => {
                        if (index > 0) handleChange(index - 1);
                    }}
                    selectProps={{
                        value: selectedProfile ? selectedProfile.profile_type : 'Choose a profile',
                        placeholder: 'Choose a profile',
                    }}
                    labelstyle={{
                        fontSize: 16,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                    }}
                />
            )}
        </Box>
    );
};

export { WorkProfileSelector };
